function ErrorMessage({message}){


 return (
  <div className="alert alert-danger" role="alert">
   {message} {message === 'El archivo ya ha sido procesado' ? <b>Por favor acceda al siguiente enlace: <a href={`${window.location.origin}/logs`}>{`${window.location.origin}/logs`}</a></b> : ''}
  </div>
 )
}
export default ErrorMessage;